import * as $ from 'jquery';

export function getProductSlug() {
    const el = $('[data-product-slug]');
    if (el.length > 0) {
        return el.attr('data-product-slug');
    }
    return 'products';
}